export default __webpack_public_path__ + "static/media/p62.c08c3bca.jpg";